export default __webpack_public_path__ + "static/media/Artboard 1.fbc5152c.png";